import type { ReviewRowModel } from '@seek/libs-shared';
import { Helmet } from 'react-helmet';
import { mapToJsonLd } from './mapper';

export interface SeoStructuredData {
  name: string;
  ratingCount: number;
  ratingValue: number;
  location?: string;
  logo?: string;
  reviews?: ReviewRowModel[];
  url?: string;
}
interface SeoStructuredDataProps {
  data?: SeoStructuredData;
}

export const SeoStructuredData = ({ data }: SeoStructuredDataProps) => {
  if (!data) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(mapToJsonLd(data))}
      </script>
    </Helmet>
  );
};
